import React from 'react';
import Accomplishment from '../common/Accomplishment/Accomplishment';
import TechLine from '../common/TechLine/TechLine';
import './Project.css';


const Project = ({ name, technologies, bullets }) => {
  return (
    <div className="project">
      <h3 className="project-name">{name}</h3>
      <TechLine text={technologies} />
      <Accomplishment data={bullets} />
    </div>
  )
}

export default Project;
